import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    overflowY: "auto",
    margin:"10px 0px"
  },

}));


export default useStyles;
